import { createActionTypes } from '../utils/reduxUtils';

enum infoActions {
  INFO_LOAD,
  INFO_SUCCESS,
  INFO_FAILED,
}

const actionTypes = createActionTypes(infoActions, 'info');

export default actionTypes;
